import React from "react";
import {MDBBadge, MDBContainer, MDBRow, MDBCardFooter, MDBCol } from 'mdb-react-ui-kit';
import serviziData from '../servizi/data/output'
import autocertData from '../Autocertificazioni/data/output'
import docStip from '../DocumentiStipula/data/output'

const TagComponent = () => {

  const location_origin = typeof window !== "undefined" ? `${window.location.origin.toString()}/` : `https://www.notaio-treviso.com/`
  
  return (
    <MDBContainer className='mt-4 mb-4 text-center'>
      {serviziData.map((item) => {
          return (
            <MDBBadge pill className='mx-2' color='success'>
              <a style={{color:'white'}} title={`Notaio Treviso - ${`${item.name} | Notaio Treviso`}`} href={`${location_origin}servizi/${item.link}`}>{`${item.name} | Notaio Treviso`}</a>
            </MDBBadge>
          );
        }
      )}

      {autocertData.map((item) => {
          return (
            <MDBBadge pill className='mx-2' color='info'>
              <a style={{color:'white'}} title={`Notaio Treviso - ${`${item.name} | Notaio Treviso`}`} href={`${location_origin}servizi/autocertificazioni/${item.link}`}>{`${item.name} | Notaio Treviso`}</a>
            </MDBBadge>
          );
        }
        )}

      {docStip.map((item) => {
          return (
            <MDBBadge pill className='mx-2' color='secondary'>
              <a style={{color:'white'}} title={`Notaio Treviso - ${`${item.name} | Notaio Treviso`}`} href={`${location_origin}servizi/documenti-stipula/${item.link}`}>{`${item.name} | Notaio Treviso`}</a>
            </MDBBadge>
          );
        }
        )}
    </MDBContainer>
  );
};

export default TagComponent;